export default {
  GET_VISITOR_LOGS_REQUEST: "GET_VISITOR_LOGS_REQUEST",
  GET_VISITOR_LOGS_RESPONSE: "GET_VISITOR_LOGS_RESPONSE",
  GET_VISITOR_LOGS_RESPONSE_CLEAR: "GET_VISITOR_LOGS_RESPONSE_CLEAR",
  GET_SINGLE_VISITOR_LOGS_REQUEST: "GET_SINGLE_VISITOR_LOGS_REQUEST",
  GET_SINGLE_VISITOR_LOGS_RESPONSE: "GET_SINGLE_VISITOR_LOGS_RESPONSE",
  GET_SINGLE_VISITOR_LOGS_RESPONSE_CLEAR:
    "GET_SINGLE_VISITOR_LOGS_RESPONSE_CLEAR",
  POST_OTP_ACTION_REQUEST: "POST_OTP_ACTION_REQUEST",
  POST_OTP_ACTION_RESPONSE: "POST_OTP_ACTION_RESPONSE",
  POST_OTP_ACTION_RESPONSE_CLEAR: "POST_OTP_ACTION_RESPONSE_CLEAR",
  POST_MEDIA_UPLOAD_REQUEST: "POST_MEDIA_UPLOAD_REQUEST",
  POST_MEDIA_UPLOAD_RESPONSE: "POST_MEDIA_UPLOAD_RESPONSE",
  POST_MEDIA_UPLOAD_RESPONSE_CLEAR: "POST_MEDIA_UPLOAD_RESPONSE_CLEAR",
  POST_VISTOR_LOG_REQUEST: "POST_VISTOR_LOG_REQUEST",
  PUT_CHECKOUT_VISTOR_LOG_REQUEST: "PUT_CHECKOUT_VISTOR_LOG_REQUEST",
  PUT_CHECKOUT_VISTOR_LOG_RESPONSE: "PUT_CHECKOUT_VISTOR_LOG_RESPONSE",
  POST_VISTOR_LOG_RESPONSE: "POST_VISTOR_LOG_RESPONSE",
  POST_VISTOR_LOG_RESPONSE_CLEAR: "POST_VISTOR_LOG_RESPONSE_CLEAR",
  PUT_VISTOR_LOG_REQUEST: "PUT_VISTOR_LOG_REQUEST",
  PUT_VISTOR_LOG_RESPONSE: "PUT_VISTOR_LOG_RESPONSE",
  PUT_STATUS_VISTOR_LOG_REQUEST: "PUT_STATUS_VISTOR_LOG_REQUEST",
  PUT_STATUS_VISTOR_LOG_RESPONSE: "PUT_STATUS_VISTOR_LOG_RESPONSE",
  DELETE_VISITOR_LOG_REQUEST: "DELETE_VISITOR_LOG_REQUEST",
  DELETE_VISITOR_LOG_RESPONSE: "DELETE_VISITOR_LOG_RESPONSE",
  DELETE_VISITOR_LOG_RESPONSE_CLEAR: "DELETE_VISITOR_LOG_RESPONSE_CLEAR",
  POST_EXCEL_VISITOR_LOG_REQUEST: "POST_EXCEL_VISITOR_LOG_REQUEST",
  POST_EXCEL_VISITOR_LOG_RESPONSE: "POST_EXCEL_VISITOR_LOG_RESPONSE",
  POST_EXCEL_VISITOR_LOG_RESPONSE_CLEAR:
    "POST_EXCEL_VISITOR_LOG_RESPONSE_CLEAR",
  POST_EXCEL_RECORDS_VISITOR_LOG_REQUEST:
    "POST_EXCEL_RECORDS_VISITOR_LOG_REQUEST",
  POST_EXCEL_RECORDS_VISITOR_LOG_RESPONSE:
    "POST_EXCEL_RECORDS_VISITOR_LOG_RESPONSE",
  POST_EXCEL_RECORDS_VISITOR_LOG_RESPONSE_CLEAR:
    "POST_EXCEL_RECORDS_VISITOR_LOG_RESPONSE_CLEAR",
  PUT_VISTOR_LOG_REMINDER_REQUEST: "PUT_VISTOR_LOG_REMINDER_REQUEST",
  PUT_VISTOR_LOG_REMINDER_RESPONSE: "PUT_VISTOR_LOG_REMINDER_RESPONSE",
};
